// the channel's own screens: their markup is rendered into a <template> by partials/custom/head.ejs (so
// index.ejs needs no extra include) and moved in beside ws4kp's displays, ahead of the ticker. This runs when the
// bundle loads, before DOMContentLoaded, so each display finds its element and the plate swap reaches its header.
const template = document.querySelector('#rhl-displays');
const container = document.querySelector('#container');
if (template && container) {
	container.insertBefore(template.content.cloneNode(true), container.querySelector(':scope > .scroll'));
}
